// extracted by mini-css-extract-plugin
export default {"ddayElementWrapper":"ddayListElement_ddayElementWrapper__9eGVz","ddayEmoji":"ddayListElement_ddayEmoji__tmezP","ddayInfoContainer":"ddayListElement_ddayInfoContainer__W5VpU"};